import type { SideBarItemsProps } from "@/components/AppSidebar";
import {
  ActionCenterMenuIcon,
  ChatMenuIcon,
  DashboardMenuIcon,
  ScheduleMenuIcon,
  SettingsMenuIcon,
} from "@/assets";

const SIDEBAR_ICONS = {
  dashboard: DashboardMenuIcon,
  schedule: ScheduleMenuIcon,
  chat: ChatMenuIcon,
  actionCenter: ActionCenterMenuIcon,
  settings: SettingsMenuIcon,
} as const;

export const mainSidebarMenu: SideBarItemsProps[] = [
  {
    title: "Dashboard",
    url: "dashboard",
    activeBg: "#1CACE0",
    activeTextColor: "#FFFFFF",
    icon: SIDEBAR_ICONS.dashboard,
    subMenu: [],
  },
  {
    title: "Schedule",
    url: "schedule",
    activeBg: "#1CACE0",
    activeTextColor: "#FFFFFF",
    icon: SIDEBAR_ICONS.schedule,
    subMenu: [],
  },
  {
    title: "Chat",
    url: "chat",
    activeBg: "#1CACE0",
    activeTextColor: "#FFFFFF",
    icon: SIDEBAR_ICONS.chat,
    subMenu: [],
  },
  {
    title: "Action Center",
    url: "action-center",
    activeBg: "#1CACE0",
    activeTextColor: "#FFFFFF",
    icon: SIDEBAR_ICONS.actionCenter,
    subMenu: [],
  },
  {
    title: "Settings",
    url: "settings",
    activeBg: "#1CACE0",
    activeTextColor: "#FFFFFF",
    icon: SIDEBAR_ICONS.settings,
    subMenu: [
      {
        title: "Accounts",
        url: "settings/accounts",
      },
    ],
  },
];
